"use client";

import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

import ChevronTop from "ui/icon/shared/ChevronTop";

const BACK_TO_TOP_THRESHOLD = 120;
const SCROLL_CONTAINER_ID = "my-content";

export const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const content = document.getElementById(SCROLL_CONTAINER_ID);
    if (!content) return;

    const toggleVisibility = () => {
      if (content.scrollTop > BACK_TO_TOP_THRESHOLD) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    content.addEventListener("scroll", toggleVisibility);
    toggleVisibility();

    return () => {
      content.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    const content = document.getElementById(SCROLL_CONTAINER_ID);
    if (content) {
      content.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <button
      className={twMerge(
        "fixed bottom-20 right-5 z-50 flex size-12 items-center justify-center rounded-full bg-sky-600 text-white shadow-[4px_1px_4px_rgba(0,0,0,.3)] transition-all duration-300 hover:bg-sky-500 lg:bottom-7 lg:right-7 lg:size-[60px]",
        isVisible
          ? "pointer-events-auto opacity-100"
          : "pointer-events-none opacity-0"
      )}
      aria-label="Back to top"
      onClick={scrollToTop}
    >
      <div className="flex flex-col items-center justify-center gap-y-0.5">
        <ChevronTop className="w-4 lg:w-5" />
        <span className="text-xs font-bold lg:text-sm">Top</span>
      </div>
    </button>
  );
};
